<span class="{{canReload ? 'reload-na-value' : ''}}" (click)="naClick($event)"
  title="Click to reload">{{valueToShow}}</span><img *ngIf="isWaiting" src="/assets/spinner.gif" class="spinner" />
